
import React, { useContext } from 'react';
import { Heading, Text, ArrowLink, Spacer } from 'react-onei';
import { events } from '../../../conf/tags_ga.conf';
import UserContext from '../../../context/UserContext';
import TagService from '../../../services/TagService';

const ContactAccountOwnerMessage = () => {
    const { wording, serviceConf } = useContext(UserContext);
    const { redirectUrl } = serviceConf;
    const { WLOST_260, WLOST_262, WBUTTON_004 } = wording;

    return (
        <div>
            <Heading as="h4" id="mbal-cannot-use-contact-label" className="spacing-m">
                {WLOST_260}
            </Heading>
            <Text id="mbal-cannot-use-contact-indication">
                {WLOST_262}
            </Text>
            <ArrowLink
                href={redirectUrl}
                id="mbal-cannot-use-contact"
                onClick={() => TagService.sendEvent(events.multibalCannotUseContact)}
                aria-label={WBUTTON_004}
                title={WBUTTON_004}
                variant="previous"
            >
                {WBUTTON_004}
            </ArrowLink>
            <Spacer color="grey4" className="spacing-xs" />
        </div>
    )
}

export default ContactAccountOwnerMessage;